export enum TenantTypeEnum {
  INDUSTRIAL = 'industrial',
  CSO = 'cso',
  COMMON = 'common',
  OUTSOURCER = 'outsourcer'
}